import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Alert } from '../Alert';
export const SnackbarContent = /*#__PURE__*/ React.forwardRef(function SnackbarContent({ message, severity, action, ...otherProps }, ref) {
    return /*#__PURE__*/ _jsx(Alert, {
        ref: ref,
        ...otherProps,
        severity: severity,
        sx: {
            minWidth: 300,
            [`&.MuiAlert-root`]: {
                alignItems: 'center',
                gap: 1
            }
        },
        "aria-describedby": "snackbar-content",
        Action: action,
        children: /*#__PURE__*/ _jsx("div", {
            id: "snackbar-content",
            children: message
        })
    });
});

//# sourceMappingURL=SnackbarContent.js.map